module.exports = __webpack_public_path__ + "static/media/Protective_Gloves.5bc89a94.svg";